import { styled } from '@mui/material';
import { VOICE_LOUDNESS_COLORS } from './colors';

export const Surface = styled('section')(
  {
    position: 'relative',
    zIndex: 20,
    width: '100%',
    minHeight: 240,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    background: '#eef3f6',
    overflow: 'hidden',
  },
);

export const Gauge = styled('div')({
  width: 360,
  height: 210,
});

export const Adjustment = styled('button')(({ position }) => ({
  position: 'absolute',
  top: position === 'top' ? 18 : 48,
  right: 18,
  border: 0,
  padding: 0,
  background: 'transparent',
  color: VOICE_LOUDNESS_COLORS.TEXT,
  fontSize: 11,
  cursor: 'pointer',
  '&::after': {
    content: '""',
    display: 'inline-block',
    marginLeft: 5,
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    ...(position === 'top'
      ? { borderBottom: '12px solid currentColor' }
      : { borderTop: '12px solid currentColor' }),
  },
}));
